import React, { useEffect } from 'react';

import FeatureSection from './FeatureSection';
import PegBoardHighlight from './PegBoardHighlight';
import PricingPlans from './PricingPlans';
import FAQSection from './FAQSection';
import useMobileCheck from '../../mobile';

import { useDispatch } from 'react-redux';

import phoneMockup from '../../assets/hero-img-small.png';
import { setHeroTitle, setHeroContent, setHeroImageURL, setHeroImage } from '../../redux/hero.slice'
import { PAGE_METADATA } from '../../pageMetadata';
import PageMetadata from '../../shared/PageMetadata';

const HomePage = () => { 
  const { isMobile } = useMobileCheck();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setHeroTitle(`Better Games. Fair Play.
          Smarter Club Management.`));
    dispatch(setHeroContent(`ShuttleOps is the all-in-one platform designed to streamline badminton
club operations, ensuring fair play and enhanced player engagement.`))
    
  }, [dispatch]);


  useEffect(() => {
    dispatch(setHeroImage(!isMobile));
    if ( !isMobile ) { 
      dispatch(setHeroImageURL(phoneMockup));
    } else { 
      dispatch(setHeroImageURL(null));
    }
  }, [dispatch, isMobile]);

  return ( 
    <>
      <PageMetadata metadata={PAGE_METADATA['/']} />
      <FeatureSection />
      <PegBoardHighlight />
      <PricingPlans />
      <FAQSection />
    </>
  )
}

export default HomePage;
